<template>
    <div class="scan">


        <div >
            
            <el-tabs v-model="activeName"   @tab-click="handleClick"  style="height: 100%" >

                <el-tab-pane label="扫描管理" name="scan">
                    <!-- <template slot="label">
                        <span style="font-size: 20px; font-weight: bold;">扫描管理</span>
                    </template> -->
                     <el-row>
                        <el-col :span="4">
                            <div v-if="isInCefClient" > 


                                <el-alert v-if="scanSearchForm.examId != null && (!isBindCard )" center type="error" effect="dark" style="margin-top: 20px;">
                                    <div>
                                        <span>您尚未绑定答题卡</span> <el-button type="text" size ="mini" icon="search" @click='isBindCardRoute'>点击绑定</el-button>
                                    </div>
                                </el-alert>

                                <el-alert v-if="scanSearchForm.examId != null && (!isAnswer)" center type="error" effect="dark" style="margin-top: 20px;">
                                    <div>
                                        <span>您尚未设置答案</span> <el-button type="text" size ="mini" icon="search" @click='openNewExamTopicDialog'>点击设置</el-button>
                                    </div>
                                </el-alert>


                                <el-card class="box-card" >
                                    <div style="font-size: 30px;color: red;font-weight: bold; ">
                                        <span>定位异常：</span>
                                        <span style="font-size: 28px;color: red;">{{ exceptList.length }}</span>
                                        <span> 张</span>
                                    </div>
                                </el-card>

                                <el-card class="box-card2"  >

                                    <div style="font-size: 20px;font-weight: bold;">  
                                        <span>已上传：</span>
                                        <span style="font-size: 28px;color: #007bff;">{{ totalResult }}</span>
                                        <span> 张</span>
                                        <el-button type="primary" size ="mini" icon="search"  style="margin-left: 5px" @click='reloadBatch'>刷新</el-button>
                                    </div> 


                                        <table border="1 " style="margin-top: 20px;width: 100%;">
                                            <tr>
                                                <th>序号</th>
                                                <!-- <th>批次</th> -->
                                                <th>扫描(张)</th>
                                                <th>上传(张)</th>
                                                <th>操作</th>
                                                <!-- <th>数量(张)</th> -->
                                            </tr>
                                            <tr v-for="(item, index) in batchResult" :key="index">  
                                                <td>{{ index + 1 }}</td>  
                                                <td>{{ item.total_nums }} </td>
                                                <td>{{ item.actual_nums }} </td>
                                                <td>
                                                    <el-button 
                                                        v-if="item.total_nums !== item.actual_nums"
                                                        type="primary" 
                                                        size="mini" 
                                                        @click="handleRetry(item)">
                                                        补传
                                                    </el-button>
                                                </td>

                                                <!-- <td>{{ batchResult.length - index }}</td>   -->
                                                <!-- <td>{{ item.batch_id }} </td>   -->
                                                <!-- <td>{{ item.total_num }} </td> -->
                                                <!-- <td>{{ item.db_nums }} </td>     -->
                                            </tr>  
                                        </table>
                                    </el-card>

                            </div>


                        </el-col>

                        <el-col :span="20"> 




                    <el-form  :inline="true" :model='scanSearchForm'  :rules="scanSearchRules" ref="scanSearchForm" class="inline-form"  > 
                        <el-row style="width: 100%;">
                            <el-col :span="6" >
                                <el-form-item label="设备列表："  prop="deviceId">
                                    <el-select v-model="scanSearchForm.deviceId" filterable placeholder="请选择"  @change="deviceChange">
                                        <el-option v-for="item in deviceList" :key="item.deviceID" :label="item.deviceName" :value="item.deviceID">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="考试列表：" prop="examId" style="width: 100%;" id="form-item-examId">
                                    <el-select v-model="scanSearchForm.examId" filterable placeholder="请选择"  @change="examChange" :style="{ width: selectWidth }">
                                        <el-option v-for="item in examList" :key="item.id" :label="item.name+'('+item.id+')'" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="6" >
                                <el-form-item >
                                    <el-button type="primary" size ="mini" icon="search" :disabled="!canScan || !isBindCard" @click='startScan'>扫描</el-button>
                                    <el-button type="danger" size ="mini" icon="search"  @click='wxSend' style="margin-left: 20px;" v-if="wxSendType == 0">通知服务人员</el-button>
                                    <el-button type="info" size ="mini" icon="search"  v-else @click='wxSend' style="margin-left: 20px;background-color:#c8c9cc;color:#fff;border-color: #c8c9cc;">已通知服务人员</el-button>
                                    <el-button type="info" style="background-color:#67c23a;color:#fff;border-color: #67c23a;margin-left: 50px; " size ="mini" icon="search" @click="setDialogInfo('logout')" >退出</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                    </el-form>

                    <!-- 扫描图片列表 -->
                    <el-row v-if="isInCefClient && imageList.length > 0" style="margin-top: 15px;">
<!-- {{ this.imageList }} -->
                        <el-col :span="5" v-for="(item, index) in imageList" :key="item.fullName" :offset="(index % 4) > 0 ? 1 : 0" style="padding: 10px;">
                            <el-card :body-style="{ padding: '0px' }">
                                <el-image class="image" fit="contain"
                                        :src="'data:image/png;base64,'+item.imgStr" :preview-src-list="['data:image/png;base64,'+item.imgStr]">
                                </el-image>
                                <div style="padding: 14px;">
                                    <span>{{item.name}}</span>
                                    <div class="bottom clearfix">
                                        <time class="time" v-if="item.status=='00'" style="color: red;">未上传</time>
                                        <time class="time" v-if="item.status=='01'">已上传</time>
                <!--                            <el-button type="danger"  size="mini" class="button" @click="deleteImage(index)">删除</el-button>-->
                                    </div>
                                </div>
                            </el-card>
                        </el-col>


                    </el-row>

                    <!--扫描图片上传按钮  -->
                    <el-row v-if="isInCefClient && imageList.length > 0" style="margin-top: 30px; width: 85%" class="fixed-bottom" >
                        <!-- <el-col :span="12" v-if="!isAutoUpload" :offset="5" > -->
                            <el-button type="primary" icon="el-icon-top" :loading="isUploading" @click='startUpload' style="width: 100%;height: 100%" v-if="!isAutoUpload || !isBindCard" >上传</el-button>
                        <!-- </el-col> -->

                    </el-row>



                    <!-- <el-button type="primary" icon="el-icon-top" :loading="isUploading" @click='startUpload'>测试上传</el-button> -->


                        </el-col>
                    </el-row>

                </el-tab-pane>



                <el-tab-pane label="定位异常" name="locationError">
                    <!-- <template slot="label">
                        <span style="font-size: 20px; font-weight: bold;">定位异常</span>
                    </template> -->
                    <div class="location-layout" v-show="exceptList.length != 0">
                    <el-row class="full-height-row">

                        <el-col :span="3" class="location-title">
                            <div class="location-div">
                                <el-row class="data-row" v-if="exceptList && exceptList.length > 0" v-for="(item, index) in exceptList">
                                    <el-col :span="24" style="margin-top: 10px;">
                                        <el-link type="primary" @click="getLocationSrc(item)">{{getExceptName(index+1, item)}}</el-link>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>

                        <el-col :span="18" >
                            <div class="image-container" @wheel="handleWheel" style="height: 100%">  
                                <img v-if="imgUrl != null" :src="imgUrl" alt="Description" :style="{ transform: `scale(${scale})` , height: '100%'}" />  
                            </div>  
                            <!-- <img src="https://sh-vknow-admin.obs.cn-east-3.myhuaweicloud.com/exam_v1/4832/20260323_173113628/10.jpg"/>   -->
                        </el-col>

                        <el-col :span="2"></el-col>

                    </el-row>
                    </div>

                    <h1  v-show="exceptList.length == 0" style="font-size: 25px; text-align:center">  无定位异常的数据 </h1>

                </el-tab-pane>

                <el-tab-pane  label="答题卡校对" name="scantron"  >
                    <!-- <template slot="label">
                        <span style="font-size: 20px; font-weight: bold;">答题卡校对</span>
                    </template> -->
                    <!-- <div v-if="imgList.length == 0">
                        <h1  style="font-size: 30px; text-align:center">  未获取到上传的试卷图片，请上传图片后再进行校对</h1>
                    </div>

                    <div v-show="imgList.length != 0" >
                        <el-row>
                            <el-col :span="4" class="locationTitle">
                                <div v-for= "(item,index) in imgList"  style="height: 25px ; padding: 5px ;border-bottom: 1px solid #d3d3d3;"  v-show="imgList.length != 0">
                                    <el-link @click="getBatchImgList(item)" type="primary"> {{index +1}}. 试卷{{ item.seq }}</el-link>
                                </div>

                            </el-col>

                            <el-col :span="16" >
                                <drawScantron ref="draw"></drawScantron>
                            </el-col>
                    

                        
                            <el-col :span="4" v-show="checkImage">
                                <el-row class="base-info" >
                                    <el-col :span="24">
                                        基本信息
                                    </el-col>
                                    <el-col :span="24">
                                        <div class="flex-box">
                                            <span>批次号：{{basicInfo.batchId}}</span>
                                        </div>
                                    </el-col>
                                    <el-col :span="24">
                                        序号：{{basicInfo.seq}}
                                    </el-col>
                                    <el-col :span="24">
                                        答题卡类型： <span v-if="pageSize == 1 || (pageSize == 2 && basicInfo.seq % 2 == 0)"> 正面</span> <span v-if="pageSize == 2 && basicInfo.seq % 2 != 0">背面</span>
                                    </el-col>
                                    <el-col :span="24" style="color: #F6F7FC;white-space:nowrap;">
                                        id：{{basicInfo.id}}
                                    </el-col>
                                    <el-col :span="24" style="color: #F6F7FC;white-space:nowrap;">
                                        same id：{{basicInfo.same_exam_id}}
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div> -->
                    

                    <div class="location-layout" v-show="preList.length != 0">
                        <el-row class="full-height-row">

                            <el-col :span="3" class="location-title">
                                <div class="location-div">
                                    <el-row class="data-row" v-if="preList && preList.length > 0" v-for="(item, index) in preList">
                                        <el-col :span="24" style="margin-top: 10px;">
                                            <el-link type="primary" @click="openWaiting(item)">{{index+1+ (waitForm.pageNo-1)* waitForm.pageSize}}、卷{{"-"+item.seq}}{{item.page_no > 1?"-第二页":""}}</el-link>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                            <el-col :span="18" >
                                <waitPage ref="waitPage"  :info="selWait" @ok="examChange" @changeExam="waitCurrentChange(1)"></waitPage>
                            </el-col>
                            <el-col :span="2"></el-col>
                        </el-row>
                    </div>

                    <h1  v-show="preList.length == 0" style="font-size: 25px; text-align:center">  考试数据已校对结束</h1>


                    
                </el-tab-pane>
            </el-tabs>
        </div>


    </div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import newExamTopicDialog from "../exam/newExam/newExamTopicDialog";
    import bindExamDialog from "../exam/newExam/bindExamDialog";
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";
    import drawScantron from "./drawScantron";
    import waitPage from "./waitPage";
    

    export default {
        name: 'scan',
        data(){
            return {
                tableData: [], tableHeight:0, myStyle: null, iframeHeight: 100,
                loading:true, isInCefClient:false, canScan: false, tipVisible: false, tipUpload: false,
                isTwoPage: false, isScanContinue: false, isUploading: false, isAutoUpload: false,
                deviceList: [], 
                imageList: [],
                // imageList: ['1','2','1','2','1','2','1','2','1','2','1','2','1','2','1','2','1','2','1','2','1','2','1','2'],
                imageList2:[{
                    "name": "0",
                    "index": 0,
                    "fullName": "E:/VKnow_history/caspaper/caspaper_histoty_1127/caspaper/CSharp/VknowCefApp/VknowCefApp/bin/Debug/data/福州演示/11111/演示001/0.png",
                    "status": "00",
                    "imgStr": "/9j/4AAQSkZJRgABAQEAyADIAAD/2wBDAAgGBgcGBQgHBw",
                    "deviceInfo": "福州的电脑", 
                    "ossName": "exams/福州演示/11111/演示001/20260731_171616/0.png" 
                },{
                    "name": "1",
                    "index": 1,
                    "fullName": "E:/VKnow_history/caspaper/caspaper_histoty_1127/caspaper/CSharp/VknowCefApp/VknowCefApp/bin/Debug/data/福州演示/11111/演示001/1.png",
                    "status": "00",
                    "imgStr": "/9j/4AAQSkZJRgABAQEAyADIAAD/2wBDAAgGBgcGBQgHBw",
                    "deviceInfo": "福州的电脑", 
                    "ossName": "exams/福州演示/11111/演示001/20260731_171616/0.png" 
                }],
                examList: [], 
                selExam: null, 
                isBindCard: true, 
                isAnswer: true,
                examCount: {ocring: 0, except: 0, ocred: 0},
                img64: '',
                deviceInfo: null, batchId: null, autoUploadCount: 0, oldImageCount: 0,
                scanSearchForm:{ deviceId: null, examId: null, scanContinue: 0, scanCount: 1,last_batch_count:0},
                scanSearchRules: {
                    deviceId: [{ required: true, message: '请选择扫描仪', trigger: 'blur' }],
                    examId: [{ required: true, message: '请选择试卷', trigger: 'blur' }],
                },
                leftStyle: null,
                batchId2: null,
                // 统计扫描列表
                batchResult:[],
                batchTotal: 0,
                selectWidth:0,
                code: 0,
                leftStyle: null,
                // 标签页
                activeName: 'scan',
                // 定位异常列表
                locationsErrorList:[],
                exceptList:[],
                imgUrl: null,
                scale: 1, // 初始缩放比例  
                // 图片列表
                imgList:[],
                imgUrl_page: null,
                basicInfo: [],
                imgUrl_A: null,
                imgUrl_B: null,
                // 答题卡信息
                scantronInfo: null,
                // 图片比例
                w_sc: 0,
                h_sc: 0,
                offsetTop:0,
                offsetLeft: 0,
                currentWidth: 0,
                currentHeight: 0,
                image_width: null,
                image_height:null,
                pageA:[],
                pageB:[],
                pageSize: 0,
                checkImage: false,
                // 待校对数据
                preList:[],
                waitForm: { 
                    pageNo: 1,
                    pageSize: 50, 
                    totalCount: 0, 
                    searchText: null,  
                },
                selWait: null,
                // 通知服务人员
                wxSendStatus:0,
                wxSendType: 0,

                
            }
        },
        components:{
            Pagination, newExamTopicDialog, bindExamDialog,drawScantron,waitPage
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
            // 计算总的上传总数
            totalResult(){
              let sum = 0
            //   this.batchResult.forEach(item=> sum += item.db_nums)
              this.batchResult.forEach(item=> sum += item.total_nums)
              return sum
            },
        },
        timers: {
            autoUpload: {time: 1000, autostart: false, repeat: true},
        },
        beforeDestroy() {
            this.clearTimers()
        },
        created() {
            
            window.cef2Web = this.cef2Web;
            window.cef2Image = this.cef2Image;
            window.scanning = this.scanning;
            window.scanCancel = this.scanCancel;
            window.scanComplete = this.scanComplete;
            window.uploading = this.uploading;
            window.uploadSuccess = this.uploadSuccess;
            window.uploadComplete = this.uploadComplete;
            window.uploadSuccess_mq = this.uploadSuccess_mq;
            window.uploadComplete_mq = this.uploadComplete_mq;
            window.uploadFail = this.uploadFail;
            window.getCrurInfo = this.getCrurInfo;
            // window.batchCheckCount = this.batchCheckCount;
            this.leftStyle = {height: (myHeight-200) + 'px', overflow: 'auto',backgroundColor: 'red'};
            // 创建定时器
            this._timers = []
        },
      	mounted() {
            // this.$message("aaaaaaaa")
            // 获取考试列表高宽，控制选择题框的长度
            const element = document.getElementById('form-item-examId');  

            // 获取计算样式  
            const computedStyle = window.getComputedStyle(element);  

            // 获取特定的样式属性  
            this.selectWidth = parseInt(computedStyle.width) * 0.8 + 'px';  

            if(typeof scanManager == 'undefined'){
                this.isInCefClient = false;
            }else{
                this.isInCefClient = true;
                let s = JSON.stringify({key: "init"});
                console.log("exec", s)
                let respStr = twainManager.exec(s);
                console.log("resp", respStr)
                this.loadDeviceList();
                let that = this;
                setTimeout(function () {
                    that.tipVisible = true;
                }, 1000);
            }
            this.loadExamList();

            //  初始化 CefSharp 绑定,用于扫描页面和扫描客户端交互
            this.initCefSharp();

            setInterval(() => {
                this.loadScanCount()
            }, 5000);
	   },
        methods: {
            ...mapActions('user',['setUserInfo']),
            countAndSort(){
                this.loadScanCount();
                // this.imageList = XEUtils.sortBy(this.imageList, 'status').reverse()
            },
            loadDeviceList(){
                if(this.isInCefClient){
                    let j = {key: "deviceInfo"};
                    let s = JSON.stringify(j);
                    console.log("exec", s)
                    let respStr = twainManager.exec(s);
                    if(respStr && respStr != ''){
                        let resp = JSON.parse(respStr);
                        if(resp.list){
                            this.deviceList = resp.list;
                            this.deviceList.unshift({deviceID: null, deviceName: '无'})
                            if(this.deviceList.length == 1){
                                this.scanSearchForm.deviceId = this.deviceList[0].deviceID;
                                this.canScan = true;
                            }
                        }
                    }
                    console.log("resp", respStr)
                }
            },
            deviceChange(){
                this.canScan = true;
                if(this.isInCefClient){
                    let deviceName = "test";
                    let deviceId = parseInt(this.scanSearchForm.deviceId);
                    let ar = XEUtils.find(this.deviceList, item => {
                        return item.deviceID === deviceId;
                    });
                    if(ar){
                        deviceName = ar.deviceName;
                    }
                    console.log("deviceName", deviceName);
                    let s = JSON.stringify({key: "loadSourceCaps", deviceId: deviceId, deviceName: deviceName});
                    console.log("exec", s)
                    let respStr = twainManager.exec(s);
                    console.log("resp", respStr)
                    // 读取设备列表时 同步发送扫描人员信息
                    this.getCrurInfo()
                }
         
            },
            loadLastScanCount(){
              // 获取最后一批次上传的试卷数量
              if(this.scanSearchForm.examId == null) return;
              let search = { licenceId: this.userInfo.licenceId, examId: this.scanSearchForm.examId};
              let param = { controllerName: 'scan/scanPre', methodName: '/scanLastBatchCount', param: search};
              return simpleApi.post(param).then(({result: {code, data}}) =>  {
                if (data) {
                  this.scanSearchForm.last_batch_count = data.last_batch_count

                }
              }).catch((error) => {
                console.log("error")
              });
            },
            loadScanCount(){
              if(this.scanSearchForm.examId == null) return;
                let search = { licenceId: this.userInfo.licenceId, examId: this.scanSearchForm.examId};
                let param = { controllerName: 'scan/scanPre', methodName: '/scanCount', param: search};
                return simpleApi.post(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    this.examCount = {ocring: 0, except: 0, ocred: 0}
                    if (data) {
                        for (let i=0; i<data.length; i++){
                            this.examCount.ocring = this.examCount.ocring + data[i].status_count;
                            if(data[i].status === "Y5"){
                              this.examCount.except = this.examCount.except + data[i].status_count;
                              this.$set(this.examCount, 'except', this.examCount.except);
                            }
                        }

                    }


                }).catch((error) => {
                    console.log("error")
                });
            },
            startScan(){
                let that = this;
                this.$refs.scanSearchForm.validate((valid) => {
                    if (valid) {
                        let deviceId = mUtils.searchText(that.scanSearchForm.deviceId)
                        if(that.isInCefClient && deviceId != null){

                            that.canScan = false;
                            that.imageList = [];
                            let examId = parseInt(that.scanSearchForm.examId);
                            let examFind = XEUtils.find(that.examList, item => item.id == examId);
                            let examName = XEUtils.trim(examFind?examFind.name:examId);
                            let deviceFind = XEUtils.find(that.deviceList, item => item.deviceID == deviceId);
                            let deviceName = (deviceFind?deviceFind.deviceName:deviceId);
                            // 扫描时间戳
                            that.batchId = XEUtils.toDateString(new Date(), 'yyyyMMddHHmmssSSS');

                            let j = {key: "startScan", token: that.userInfo.token, userName: that.userInfo.nickName,
                                licenceKey: that.userInfo.licenceKey, licenceName: that.userInfo.licenceName,
                                examId: parseInt(this.scanSearchForm.examId), examName: examName,
                                deviceName: deviceName, deviceId: deviceId,
                                webBatchId: that.batchId
                            };

                            let respStr = twainManager.exec(JSON.stringify(j));
                            that.isAutoUpload = false;
                            console.log("resp", respStr);
                        }
                    }
                });
            },
            startScanAndUpload(){
                let that = this;
                this.$refs.scanSearchForm.validate((valid) => {
                    if (valid) {
                        let deviceId = mUtils.searchText(that.scanSearchForm.deviceId)
                        if(that.isInCefClient && deviceId != null){
                            that.canScan = false;
                            that.imageList = [];
                            let examId = parseInt(that.scanSearchForm.examId);
                            let examFind = XEUtils.find(that.examList, item => item.id == examId);
                            let examName = (examFind?examFind.name:examId);
                            let deviceFind = XEUtils.find(that.deviceList, item => item.deviceID == deviceId);
                            let deviceName = (deviceFind?deviceFind.deviceName:deviceId);
                            let j = {key: "startScan", token: that.userInfo.token, userName: that.userInfo.nickName,
                                licenceKey: that.userInfo.licenceKey, licenceName: that.userInfo.licenceName,
                                examId: parseInt(this.scanSearchForm.examId), examName: examName,
                                deviceName: deviceName, deviceId: deviceId};

                            let respStr = twainManager.exec(JSON.stringify(j));
                            console.log("resp", respStr);
                            this.isAutoUpload = true;
                            this.autoUploadCount = 0;
                            this.oldImageCount = 0;
                            if(!this.timers.autoUpload.isRunning) {
                                this.$timer.start('autoUpload');
                            }
                        }
                    }
                });

            },
            autoUpload(){
                if(this.isAutoUpload && this.isInCefClient){
                    if(this.autoUploadCount > 3){
                        console.log("autoUpload startUpload");
                        this.startUpload();
                        this.$timer.stop('autoUpload');
                        this.autoUploadCount = 0;
                    }
                    if(this.imageList && this.imageList.length > 0){
                        if(this.oldImageCount != this.imageList.length){
                            this.oldImageCount = this.imageList.length;
                            this.autoUploadCount = 0;
                        }else{
                            this.autoUploadCount = this.autoUploadCount + 1;
                        }
                    }
                    console.log("autoUpload", this.autoUploadCount);
                }else{
                    this.autoUploadCount = 0;
                }
            },
            loadExamList(){
                let search = { licenceId: this.userInfo.licenceId, schoolId: null, teacherId: null, scan: 'Y'};
                let role = this.userInfo.role;
                if(role == "sclAdmin") search["schoolId"] = this.userInfo.schoolId;
                if(role == "teacher") {
                    search["schoolId"] = this.userInfo.schoolId;
                    search["scanTeacherId"] = this.userInfo.id;
                }
                let param = { controllerName: 'exam', methodName: '/examList', pageNo: 0, pageSize: 500, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log(data)
                    if (data.code == 0) {
                        this.examList = data.result;
                    }
                }).catch((error) => {
                    console.log("error")
                });
            },
            examChange(v){
                debugger
                
                // 切换考试时清空上传列表
                this.batchResult = []
                this.batchTotal = 0
                console.log('examChange', v);
                let ar = XEUtils.find(this.examList, item => {
                    return item.id == v;
                })
                if(ar){
                    this.isBindCard = ar.exam_sheet_count>0?true:false;
                    this.isAnswer = ar.topic_answer_count > 0?false:true;
                }
                // wxSend 判断
                this.wxSendType = ar.scan_type
                // 切换考试号时刷新wxsend 
                this.wxSendStatus = 0
                // this.loadScanCount()

                // 加载扫描记录
                this.getScanLog()
                // 加载定位异常列表
                this.loadExceptExamList(v)
                // 加载待校对列表
                this.loadPreList(v)

                if(!this.isBindCard) this.isBindCardMessage()
            },
            openBindExamDialog(row){
                let v = this.scanSearchForm.examId;
                let ar = XEUtils.find(this.examList, item => {
                    return item.id == v;
                })
                if(ar){
                    this.selExam = Object.assign(ar,{ time: (new Date()).getMilliseconds()});
                }
                this.$refs.bindExamDialog.showDialog();
            },
            openNewExamTopicDialog(){
                let v = this.scanSearchForm.examId;
                let ar = XEUtils.find(this.examList, item => {
                    return item.id == v;
                })
                if(ar){
                    this.selExam = Object.assign({time: new Date().getMilliseconds(), randomNo: Math.round(Math.random()*50000) }, ar);
                    console.log("openNewExamTopicDialog", this.selExam);
                }
                this.$refs.newExamTopicDialog.showDialog();
            },
            bindExamOK(){
                this.scanSearchForm.examId = null;
                this.isBindCard = true;
                this.loadExamList();
            },
            topicOK(){
                this.scanSearchForm.examId = null;
                this.isAnswer = true;
                this.loadExamList();
            },
            scanning(index, fullName, imgStr, deviceInfo, ossName){
                // this.imageList.unshift({name: ""+index, index: index, fullName: fullName, status: '00', imgStr: imgStr, deviceInfo: deviceInfo, ossName: ossName});
                this.imageList.push({name: ""+index, index: index, fullName: fullName, status: '00', imgStr: imgStr, deviceInfo: deviceInfo, ossName: ossName});
                this.deviceInfo = deviceInfo;
                this.canScan = false;
                console.log("scanning", index, fullName);
            },
            scanCancel(){
                this.canScan = true;
                console.log("scanCancel");
            },
            scanComplete(scanImageCount){
                this.tipUpload = true;
                this.canScan = false;
                this.$alert("共扫描"+ scanImageCount + "张图片，请上传图片");
            },
            uploading(imageCount, imageIndex, ossName){
                console.log('uploading', imageCount, imageIndex, ossName)
                this.$notify({
                    title: '上传试卷',
                    message: ossName + '上传中，' + imageIndex + "/" + imageCount,
                    type: 'success'
                });

            },
            // mq版本的扫描回调 进行插表和mq消息发送操作
            uploadSuccess_mq(examId,seq,fileName,shortName,ossName,deviceInfo,batchId) {
                try {
                    if (window.cef) {
                        let that = this;
                        let examId = parseInt(this.scanSearchForm.examId);
                        let p = {licenceId: this.userInfo.licenceId, examId: examId, seq: seq, schoolId: this.userInfo.schoolId,
                            crur: this.userInfo.id, crurType: this.userInfo.role, batchId: batchId, status: '00', driveInfo: deviceInfo,
                            driveLocalName: fileName, ossName: ossName, scanType:'app'
                        };
                        // this.batchId2 = this.batchId
                    
                        // if(this.batchId == '' || this.batchId == undefined || this.batchId == null) this.batchId2 = batchId
                        console.log('uploadSuccess', ossName, fileName, deviceInfo, seq, batchId);
            
                        let param = { controllerName: 'scan/scanPre', methodName: '/saveOrUpdateByUpload', param: p};
                        simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                            console.log('uploadSuccess', code);
                            let title = "uploadSuccess code==> " +code + "data==>" + data 
                            
                            if (code == 0) {
                                let ar = XEUtils.find(that.imageList, item => {
                                    return item.index == seq;
                                });
                                if(ar){
                                    ar.status = '01';
                                }
                                
                                window.cef.insertResult3(examId,seq, String(batchId),fileName,shortName,ossName,'success','200');
                                // this.$notify({ title: 'insertResult 调用成功', type: 'success' });
                                // this.$notify({ title: data, type: 'success' });
                      
                            }
                        });

       
                    } else {
                        this.$notify({ title: ' window.cef 为 undefined', type: 'error' });
                    }
                } catch (e) {
                    this.$notify({ title: '调用异常: ' + e.message, type: 'error' });
                }
            },
            // 无mq版本的扫描回调 进行插表操作
            uploadSuccess(ossName, fileName, deviceInfo, seq, batchId){
                let that = this;
                let examId = parseInt(this.scanSearchForm.examId);
                let p = {licenceId: this.userInfo.licenceId, examId: examId, seq: seq, schoolId: this.userInfo.schoolId,
                    crur: this.userInfo.id, crurType: this.userInfo.role, batchId: this.batchId, status: '00', driveInfo: deviceInfo,
                    driveLocalName: fileName, ossName: ossName
                };
                this.batchId2 = this.batchId
                // this.batchId2 = batchId
                if(this.batchId == '' || this.batchId == undefined || this.batchId == null) this.batchId2 = batchId
                
                // let p = {licenceId: this.userInfo.licenceId, examId: examId, seq: seq, schoolId: this.userInfo.schoolId,
                //     crur: this.userInfo.id, crurType: this.userInfo.role, batchId: batchId, status: '00', driveInfo: deviceInfo,
                //     driveLocalName: fileName, ossName: ossName
                // };
                console.log('uploadSuccess', ossName, fileName, deviceInfo, seq, batchId);
                // let param = { controllerName: 'scan/scanPre', methodName: '/saveOrUpdate', param: p};
                let param = { controllerName: 'scan/scanPre', methodName: '/saveOrUpdateByUpload', param: p};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    console.log('uploadSuccess', code);
                    if (code == 0) {
                        let ar = XEUtils.find(that.imageList, item => {
                            return item.index == seq;
                        });
                        if(ar){
                            ar.status = '01';
                        }
                    }
                });

            },
            deleteImage(index){
                if(this.isInCefClient){
                    let that = this;
                    this.$confirm('此操作将永久删除扫描件, 是否继续?', '提示', {
                        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
                    }).then(() => {
                        let delImg = that.imageList[index];
                        let j = {key: "deleteImage", index: delImg.index };
                        let respStr = twainManager.exec(JSON.stringify(j));
                        that.imageList.splice(index,1);
                        console.log("resp", respStr);
                    }).catch(() => {

                    });


                }
            },
            startUpload(){
                if(this.isInCefClient){
                    this.code += 1
                    
                    // 扫描成功后，获取当前批次和图片数量
                    let batch = XEUtils.toDateString(new Date(), 'yyyyMMddHHmmssSSS');
                    // this.batchResult.unshift({index: this.batchResult.length +1 ,batchId: batch, nums: this.imageList.length})
                    // this.batchTotal += this.imageList.length 
                    // 新增插入批次数量（弃用）
                    // this.addScanLog(this.imageList.length)

                    let s = JSON.stringify({key: "startUpload"});
                    console.log("exec", s)
                    this.isUploading = true;

                    let respStr = twainManager.exec(s);

                    console.log("resp", respStr)
                    // 测试
                    // this.isUploading = false;
                }
            },
            wxSend(){
                let that = this;
                let param = { controllerName: 'wxTemplateLog', methodName: '/scanComplateLog', param: {examId: this.scanSearchForm.examId}};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    console.log('testSend', code, data);
                    that.$alert('我们将尽快处理', '收到', {
                        confirmButtonText: '确定',
                    });
                    // 重新刷新examList列表 但是选中的考试不被刷新
                    debugger
                });
            },
            uploadFail(){
                this.isUploading = false;
                this.$notify({title: '上传部分失败',
                    message: '部分试卷上传失败，请点击上传重新上传',
                    type: 'success'
                });
            },
            uploadComplete_dev(){
                let examId = this.scanSearchForm.examId
                let batchId = this.batchId2
                // 上传成功后新增批次记录
                this.batchCheckCount(examId,batchId)
                this.canScan = true;
                this.imageList = [];
                this.$notify({
                    title: '所有试卷',
                    message: '上传完成',
                    type: 'success'
                });
                this.loadLastScanCount();
                this.loadScanCount();
                this.isUploading = false;
            },
            async uploadComplete(){
                await this.complete()
                // 上传结束后 进行定时刷新
                this.scheduleRefresh()
            },
            complete(){
                let examId = this.scanSearchForm.examId
                let batchId = this.batchId2
                // 上传成功后新增批次记录
                this.batchCheckCount(examId,batchId)
                this.canScan = true;
                this.imageList = [];
                this.$notify({
                    title: '所有试卷',
                    message: '上传完成',
                    type: 'success'
                });
                this.loadLastScanCount();
                this.loadScanCount();
                this.isUploading = false;
            },
            scheduleRefresh() {
                this.clearTimers()
                ;[1000, 50000, 10000].forEach(delay => {
                this._timers.push(setTimeout(() => {
                    this.loadLastScanCount().catch(e => console.error('', e))
                    this.loadScanCount().catch(e => console.error('', e))
                }, delay))
                })
            },
            clearTimers() {
                (this._timers || []).forEach(clearTimeout)
                this._timers = []
            },

            uploadComplete_mq(batchId){
                // 推延一秒 防止检查早于batch.json插表
                setTimeout(() => {
                    let examId = this.scanSearchForm.examId
                    // 上传成功后新增批次记录
                    this.batchCheckCount(examId,batchId,"app")
                    this.canScan = true;
                    this.imageList = [];
                    this.$notify({
                        title: '所有试卷',
                        message: '上传完成',
                        type: 'success'
                    });
                    this.loadLastScanCount();
                    this.loadScanCount();
                    this.isUploading = false;
                },1000)
            },
            cef2Web(msg){
                this.$message(msg);
            },
            cef2Image(s){
                this.img64 = s;
            },
            // 批次比较
            batchCheckCount(examId,batchId,scanType){
                let p = {licenceId: this.userInfo.licenceId, examId : examId,batchId : batchId,crur: this.userInfo.id,scanType: scanType}
                let param = { controllerName: 'scan/scanPre', methodName: '/batchCheckCount', param: p};
                simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                    // 重新刷新记录
                    this.getScanLog()
                });
                // alert("?")
            },
            // 切换标签页
            handleClick(){
                this.checkImage = false
                // if(this.activeName == 'section')
                
                let examId = this.scanSearchForm.examId
                if(examId == null || examId == undefined || examId == ''){
                    this.$message.warning('请选择考试号')
                    return
                } 
                if(this.activeName == 'locationError'){
                    // 定位异常页面
                    // 请求定位异常数据，显示图片
                    this.loadExceptExamList(examId)

                    // let param = { controllerName: 'scan/scanPre', methodName: '/list', param: {examId: examId,inStatus: ['Y5'],orderBy: "sf.uddt", pageSize: 5000}};
                    // simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                        
                    //     this.locationsErrorList = data.result
                    // });
                }else if(this.activeName == 'scantron'){
                    this.loadPreList(examId)
                    // // 答题卡校对页面
                    // let param = { controllerName: 'scan/scanPre', methodName: '/getSheetByExamId', param: {examId: examId}};
                    // simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                     
                    //     this.pageSize = data.pageSize
                    //     // 获得批次列表
                    //     this.imgList = data.imgList
                    //     // 解析答题卡坐标信息     
                    //     this.scantronInfo = data.scantronInfo
                    //     this.$refs.draw.scantronInfo = data.scantronInfo
                    //     // 清空数据
                    //     this.$refs.draw.scanPre = []

                    // });
                }else {
                    // 上传页面
                }
            },
            // 加载定位异常的图片
            loadExceptExamList(examId){
                let search = { licenceId: this.userInfo.licenceId, examId: examId, inStatus: ['Y5', 'Y6', 'Y7']};
                let param = { controllerName: 'scan/scanPre', methodName: '/list', pageSize: 5000, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadExceptExamList", data)
                    if (data && data.code == 0) {
                        this.exceptList = data.result;
                        // if(callback) callback(data.result);
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },

            // 加载待校对数据
            loadPreList(examId){
                let search = { licenceId: this.userInfo.licenceId, examId: examId, inStatus: ['01']};
                let param = { controllerName: 'scan/scanPre', methodName: '/list', pageSize: 5000, param: search};
                return simpleApi.list(param).then(({result: {code, data}}) =>  {
                    console.log("loadPreList", data)
                    if (data && data.code == 0) {
                        this.preList = data.result;
                    }
                }).catch((error) => {
                    console.log("error", error)
                });
            },
            getLocationSrc(item){
         
                this.imgUrl = item.oss_full_name
                this.basicInfo = item
            },
            zoomIn() {  
                this.scale += 0.1; // 增加缩放比例  
            },  
            zoomOut() {  
                this.scale = Math.max(0.1, this.scale - 0.1); // 减少缩放比例，最小值为 0.1  
            },  
            handleWheel(event) {  
                event.preventDefault(); // 防止默认滚动行为  
                if (event.deltaY < 0) {  
                    this.zoomIn(); // 向上滚动放大  
                } else {  
                    this.zoomOut(); // 向下滚动缩小  
                }  
            },  
            // 获得对应批次头两张图片
            getBatchImgList(item){
                this.checkImage = true
                this.basicInfo = item
       
                this.$refs.draw.scanPre = item

                // 判断pageSize,然后根据奇偶数显示对应正反面答题卡信息
                let seq = item.seq
                let type = 1
                if(this.pageSize == 2){
                    type =  seq % 2 === 0 ? 1: 0; 
                }
                this.$refs.draw.scantronType = type
                
                // this.imgUrl_page = item.cutOssFullName == undefined ? item.ossFullName : item.cutOssFullName
                // let param = { controllerName: 'scan/scanPre', methodName: '/getBatchImgListByExamId', param: {examId: this.scanSearchForm.examId,batchId: item.batchId,pageSize: this.scantronInfo.pageSize}};
                //     simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
      
                //         this.imgUrl_A = data[0].cutOssFullName == undefined ? data[0].ossFullName : data[0].cutOssFullName
                //         // if(this.scanInfo.pageSize == 2) this.imgUrl_B = data[1].cutOssFullName == undefined ? data[1].ossFullName : data[1].cutOssFullName
                //         this.imgUrl_B = data[1].cutOssFullName == undefined ? data[1].ossFullName : data[1].cutOssFullName
                //         // this.getJsonByLocation()
                //     });
            },
            // 获取json文件中的位置信息
            getJsonByLocation(){
            // 获取位置信息
  
            let location = JSON.parse(this.scantronInfo.location)
            console.log(location);
            let  pageSheets = location.pageSheets
            pageSheets.forEach((element,index) => {
                if(index !== 1){
        
                    let postions = []
                    // 题区的顺序（从0开始）
                    let code = 0

                    // 计算答题卡与显示图片的比例
                    // 判断图片是否加载成功，未成功则提示答题卡加载中
                    this.loadingJson = this.image_width == null || this.image_height == null ? false : true

                    this.width_sc = this.image_width / this.scantronInfo.imageWidth 
                    this.height_sc =  this.image_height  / this.scantronInfo.imageHeight 

                    // 获取题目位置信息
                    let sections = element.sections
                    let selectList =[]
                    sections.forEach((element,index) => {
                        let title = "第"+ (index + 1) + "题区"
                        let id = index
                        // 判断是否是选择题，是选择题的话需要另外渲染选择框
                        let type = element.type
                        let a = element.contents.position
                        // 题块位置信息
                        let point = {
                        id: id,
                        index: index,
                        title: title,
                        type: type,
                        left: a.left * this.width_sc + this.offsetLeft,
                        top: a.top * this.height_sc + this.offsetTop,
                        height: a.height * this.height_sc,
                        width: a.width * this.width_sc,
                        // 携带题号信息
                        branch: element.contents.branch,
                        // 获得换算过的高宽
                        width_old: a.width * this.width_sc,
                        height_old: a.height * this.height_sc,
                        scantron_width: a.width,
                        scantron_height: a.height
                        }
                        // 题区顺序 +1
                        code ++
                        postions.push(point)
                    });
                    // 获取条形码学号
                    if("barCode" in element){
                        let position = element.barCode.position

                        let point = {
                        id: code,
                        type: 'barCode',
                        title:'学号',
                        left: position.left * this.width_sc + this.offsetLeft,
                        top: position.top * this.height_sc + this.offsetTop,
                        height: position.height * this.height_sc,
                        width: position.width * this.width_sc,
                        scantron_width: position.width,
                        scantron_height: position.height
                        }
                        code ++
                        postions.push(point)
                    }

                    // 获得学号
                    if("ticketNum" in element){
                        let ticketNum = element.ticketNum
                        let position = element.ticketNum.position
                        let point = {
                        id: code,
                        type: 'ticketNum',
                        title:'学号',
                        count: ticketNum.count,
                        left: position.left * this.width_sc + this.offsetLeft,
                        top: position.top * this.height_sc + this.offsetTop,
                        height: position.height * this.height_sc,
                        width: position.width * this.width_sc,
                        // 头个选项位置
                        firstOption: ticketNum.firstOption,
                        // 获得换算过的高宽
                        width_old: position.width * this.width_sc,
                        height_old: position.height * this.height_sc,
                        scantron_width: position.width,
                        scantron_height: position.height
                        }
                        code ++
                        postions.push(point)
                    }

                    // 获取作弊标识
                    if("cheatMark" in element){
                        let position = element.cheatMark.position

                        let point = {
                        id: code,
                        type:'cheatMark',
                        title:'作弊',
                        left: position.left * this.width_sc + this.offsetLeft,
                        top: position.top * this.height_sc + this.offsetTop,
                        height: position.height* this.height_sc,
                        width: position.width * this.width_sc,
                        scantron_width: position.width,
                        scantron_height: position.height
                        }
                        code ++
                        postions.push(point)
                    }

                    // 获取缺考标识
                    if("absentMark" in element){
                        let position = element.absentMark.position

                        let point = {
                        id: code,
                        type:'absentMark',
                        title:'缺考',
                        left: position.left * this.width_sc + this.offsetLeft,
                        top: position.top * this.height_sc + this.offsetTop,
                        height: position.height* this.height_sc,
                        width: position.width * this.width_sc,
                        scantron_width: position.width,
                        scantron_height: position.height


                        }
                        code ++
                        postions.push(point)
                    }

                    // 获取学号
                    this.pageA = postions
                
                }else{
                    let postions = []
                    // 题区的顺序（从0开始）
                    let code = 0

                    // 计算答题卡与显示图片的比例
                    this.width_sc = this.image_width / this.scantronInfo.imageWidth 
                    this.height_sc =  this.image_height  / this.scantronInfo.imageHeight 

                    // 获取题目位置信息
                    let sections = element.sections
                    let selectList =[]
                    sections.forEach((element,index) => {
                        let title = "第"+ (index + 1) + "题区"
                        let id = index
                        // 判断是否是选择题，是选择题的话需要另外渲染选择框
                        let type = element.type
                        let a = element.contents.position
                        // 题块位置信息
                        let point = {
                        id: id,
                        index: index,
                        title: title,
                        type: type,
                        left: a.left * this.width_sc + this.offsetLeft,
                        top: a.top * this.height_sc + this.offsetTop,
                        height: a.height * this.height_sc,
                        width: a.width * this.width_sc,
                        // 携带题号信息
                        branch: element.contents.branch,
                        // 获得换算过的高宽
                        width_old: a.width * this.width_sc,
                        height_old: a.height * this.height_sc,
                        scantron_width: a.width,
                        scantron_height: a.height
                        }
                        // postions.push(a)
                        // 题区顺序 +1
                        code ++
                        postions.push(point)
                        // selectList.push(point)
                    });


                    this.pageB = postions
                }
            });
            },
            // 答题卡校对
            openWaiting(row){
                this.selWait = row;
            },
            getExceptName(index, item){
              let status = item.status;
              return index + "." + "定位异常(" + item.seq+")";
              // if(status == "SY") return index + "." + "缺少第一页(" + item.seq+")";
              // if(status == "UN") return index + "." + "未知异常(" + item.seq+")";
              // if(status == "Y5") return index + "." + "找不到定位点(" + item.seq+")";
              // if(status == "Y6") return index + "." + "切图异常(" + item.seq+")";
              // if(status == "F1") return index + "." + "第一页已删除(" + item.seq+")";
              // if(status == "Y7") return index + "." + "不是这张试卷？(" + item.seq+")";
              // return index + ".异常";
            },
            // 未绑定答题卡不允许进行弹窗
            isBindCardMessage(){
                let title =  '提示'
                let examInfo = this.examList.filter(item => item.id == this.scanSearchForm.examId)
                if(examInfo.length > 0) title = examInfo[0].name + '(' + examInfo[0].id + ')'
                this.$confirm('考试未绑定答题卡，请前往<strong style="font-weight: bold; color: #409eff; font-size: 14px;">笔试考试</strong>处绑定答题卡后再扫描',title,{
                    confirmButtonText: '确认',
                    dangerouslyUseHTMLString: true,

                }).then(() => {
                    // this.isBindCardRoute()
                }).catch(() => {

                });
            },
            // 前往笔试考试
            isBindCardRoute(){
                // 点击转到笔试考试
                this.$router.push('/mainPage/exam/newExam')
            },
            // 查询扫描记录
            getScanLog(){
                // let search = {
                //     examId: this.scanSearchForm.examId,
                //     teacherId: this.userInfo.id
                // }
                // let param = { controllerName: 'scan/scanPreLog', methodName: '/selectLog', param: search};
                
                let search = {
                    examId: this.scanSearchForm.examId
                }
                let param = { controllerName: 'scan/scanPre', methodName: '/batchListAll', param: search};
                return simpleApi.post(param).then(({result: {code, data}}) =>  {
                    this.batchResult = data
                })
            },
            addScanLog(total){
                // 统一下时间戳格式(仅插入记录时使用)
                let str = this.batchId
                let batch = str.slice(0, 8) + '_' + str.slice(8)
                let search = {
                    examId: this.scanSearchForm.examId,
                    teacherId: this.userInfo.id,
                    batchId: batch,
                    totalNum: total
                }
                let param = { controllerName: 'scan/scanPreLog', methodName: '/insertScanLog', param: search};
                return simpleApi.post(param).then(({result: {code, data}}) =>  {
                    // 刷新
                    this.getScanLog()
                })
            },
            // 初始化
            async initCefSharp() {
                try {
                    // 判断是否在 CefSharp 环境中
                    if (typeof CefSharp !== 'undefined' && CefSharp.BindObjectAsync) {
                        await CefSharp.BindObjectAsync('cef');
                        console.log('✅ cef 绑定成功');
                        // this.$notify({ title: '✅ cef 绑定成功', type: 'success' });
                    } else {
                        console.log('⏳ 非 CefSharp 环境，跳过绑定');
                    }
                } catch (error) {
                    console.error('❌ cef 绑定失败:', error);
                    // this.$notify({ title: '❌ cef 绑定失败: ' + error.message, type: 'error' });
                }
            },
            // 扫描补传
            handleRetry(item){
                // 补传 通过examId batchId 读取本地保存的batch.json信息 重新上传
                this.$confirm(`确定要补传批次 ${item.batch_id} 吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let s = JSON.stringify({
                        key: "retryUpload",
                        batchId: item.batch_id,
                        examId: item.exam_id,
                        // batch.json 所在目录  本地存储地址
                        basePath: item.base_path  
                    });
                    twainManager.exec(s);
                    this.$message.success('补传任务已启动');
                }).catch(() => {});
            },
            // 进入页面时 自动将用户登陆信息转给后端(mq版本)
            getCrurInfo(){
                let s = JSON.stringify({
                    key: "getCrurInfo",
                    crur: this.userInfo.id,
                    crurType:  this.userInfo.role,
                    licenceId: this.userInfo.licenceId,
                    schoolId: this.userInfo.schoolId
                });
                twainManager.exec(s);
                    
            },
             /**
             * 弹出框-修改密码或者系统设置
             * @param {string} cmditem 弹框类型
             */
             setDialogInfo(cmditem) {
                switch (cmditem) {
                    case 'logout':
                        this.logout();
                        break;
                }
            },

            logout(){
                let that = this;
                this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    simpleApi.post({controllerName: 'admin', methodName: '/teacherLogout', param: { token: this.userInfo.token }}).then(({data, code}) =>  {
                        this.setUserInfo(null);
                    });
                    that.setUserInfo(null);
                    setTimeout(that.$router.push({ name: "login"}), 200);
                }).catch(() => {

                });

            },
            // 重新刷新批次记录
            reloadBatch(){
                if(this.scanSearchForm.examId == null || this.scanSearchForm.examId == '' || this.scanSearchForm.examId == undefined) return
                // 加载扫描记录
                this.getScanLog()
            }

        },
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

    .scan{
        background-color: #e5e5e52f;
        min-height: 100vh;
        height: 100%;
        .search_container{

        }
        .btnRight{
            float: right;
            margin-right: 0px !important;
        }
        .searchArea, .search-form{
            background:rgb(255, 255, 255);
            // border-radius:2px;
            // padding: 18px 18px 0;
        }
        .search-form{
            width:180px;
            position: fixed;
            height:100%;
            left:0;
            top:60px;
            z-index: 999;
            padding:10px 0px;
            .el-form-item{
                margin-right: 10px;
                margin-left: 10px;
                .el-form-item__label{
                    width:160px;
                    padding:0;
                    text-align:left;
                }
            }
            .item{
                margin-top: 20px;
                height: 35%
            }
        }
        .table_container{
            // padding: 10px;
            background: #fff;
            // border-radius: 2px;
        }
        .el-dialog--small{
            width: 600px !important;
        }
        .pagination{
            text-align: left;
            margin-top: 10px;
        }
        .time {
            font-size: 13px;
            color: #999;
        }

        .bottom {
            margin-top: 13px;
            line-height: 12px;
        }

        .button {
            padding: 0;
            float: right;
        }

        .image {
            width: 100%;
            height: 300px;
            display: block;
        }

        .clearfix:before,
        .clearfix:after {
            display: table;
            content: "";
        }

        .clearfix:after {
            clear: both
        }

        .el-tabs__header {
            // background-color: #409EFF; // 主蓝色，你可以改成截图更深的蓝色 #2b7bdd
        //     margin:10;
            box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.14);

        }

        // 可选：修改tab文字颜色，蓝色背景下文字要白色才看得清
        .el-tabs__item {
            // color:black;
            color:#a0cfff;
            font-size:20px;
            font-weight: bold;
        }
        // 激活tab样式
        .el-tabs__item.is-active {
            // color:#fff;
            color:#007bff;
            // background-color:#ffffff;
        }


    }

// 滚动条设置2倍宽度.
    // 竖向滚动条
    .is-scroll-right::-webkit-scrollbar,
    .is-scroll-left::-webkit-scrollbar,
    .el-scrollbar::-webkit-scrollbar {
      width: 16px;
      //width: 4px;
      height: 8px !important;
    }

    .fixed-bottom {
        position: fixed;
        bottom: 0;
        // left: 0;
        // right: 0;
        height: 40px;
        z-index: 1000; /* 确保在最上层 */
        // padding-top: 5px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
    }
    .inline-form {  
        /* 设置表单在容器内左对齐 */  
        display: flex; /* 使用 flexbox 来布局 */  
        // align-items: center; /* 垂直居中对齐项 */  
        width: 100%;
        text-align: left;
    }  

    .custom-card {  
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2); /* 自定义阴影 */  
    }  

  
    .tableStyle {
        margin-top: 20px;
        width: 90%;
        height: auto;
        overflow-y: auto;
    }
    .box-card{
        margin-top: 10% ;
        margin-left:5px;
        margin-right:5px; 
        width: 95%; 
        height: 100px ;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    }
    .box-card2{
        margin-top: 20%;  
        height: auto ;
        margin-left:5px;
        margin-right:5px; 
        width: 95%; 
        height: 60%;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);  
        overflow-y: auto; /* 滚动条 */
    }

    .left-part {
            // padding: 10px;
            // border: 1px solid rgba(203, 202, 202, 0.71);
            // border-bottom-left-radius: 10px;
            // border-bottom-right-radius: 10px;
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;
            .data-row{
                // margin-bottom: 10px;
                text-align: left;
            }
        }

        .right-part {
            // padding: 10px;
            // border: 1px solid rgba(203, 202, 202, 0.71);
            // border-bottom-left-radius: 10px;
            // border-bottom-right-radius: 10px;
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;

            .data-row{
                margin-bottom: 10px;
            }
            .student-no-lost {
                text-align: left;
            }
        }
        .image-container {  
            width: 98%; /* 设置 div 的宽度 */  
            overflow: hidden; /* 隐藏超出部分 */  
            position: relative; /* 为了更好地控制 img 位置 */  
            margin: 10px;
        }  

        .image-container img {  
            width: 98%;  
            height: 100%;  
            object-fit: contain; /* 确保图片完整显示，同时保持比例 */  
            transition: transform 0.2s ease; /* 平滑缩放过渡 */  
            margin: 10px;
        }  
        .locationTitle {
            height: 100%;
            text-align: left;
            padding-left: 5px;
            font-size: 20px;
            background-color: white;
            overflow: auto;
            padding: 5px;
        }
        .base-info{
            text-align: left;  
            margin-top: 10px;
            background-color: white;
            height: 100%;
            width: 100%;
        }
        .base-info2 {
            text-align: left;
            // margin-top: 10px;
            // padding: 5px;
            border: 1px solid rgba(203, 202, 202, 0.71);
            // border-bottom-left-radius: 10px;
            // border-bottom-right-radius: 10px;
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;
            // padding: 20px;
            // margin: 10px;
            background-color: white;
            .flex-box{
            display: flex;
            width: 100%;
            height: auto;
            justify-content: flex-start;
            span{
                display: flex;
                word-break: break-word;
                width: 100%;
            }
            }
    }

    .location-layout{
      height: 90vh;  /* 占满整个视口高度 */
      display: flex;
      flex-direction: column;
     
    }
    .full-height-row {
      flex: 1;
      display: flex;
      width: 100%;
      overflow: hidden;  /* 防止溢出 */
    }
    .location-title {
      
        height: 100%;
        // width: 100%;

        /* 边框 */
        border: 1px solid #dcdfe6;
        
        /* 圆角 */
        border-radius: 8px;
        
        /* 阴影 */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        
        /* 背景色（可选） */
        background-color: #e6f0ff;
        
        /* 内边距（可选） */
        padding: 10px;
        

    }
    .location-div{
      height: 100%;
      width: 95%;
      border-radius: 8px;
      
    }
    .data-row{
      // background-color: red;
      border-bottom: 1px solid #e8e8e8;
      background-color: white;
      text-align: left;
      padding: 5px
    }
    .image-container {  
        width: 98%; /* 设置 div 的宽度 */  
        overflow: hidden; /* 隐藏超出部分 */  
        position: relative; /* 为了更好地控制 img 位置 */  
        margin: 10px;
    }  
</style>


